import { render } from "./CosmoShop.vue?vue&type=template&id=efc5fc44&scoped=true"
import script from "./CosmoShop.vue?vue&type=script&lang=js"
export * from "./CosmoShop.vue?vue&type=script&lang=js"

import "./CosmoShop.vue?vue&type=style&index=0&id=efc5fc44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efc5fc44"]])

export default __exports__